import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import FRDevicesFRConfigTable from "../table/FRDevicesFRConfigTable";
import { useGetAllDevices } from "../../hooks/common/query";
import { DEVICE_TYPES, PAGE_SIZE } from "../../constants/common";
import { Device } from "../../hooks/common/interface";

interface FRDevicesConfigCardProps {
  setSelectedDeviceIPAddresses: Dispatch<SetStateAction<string[]>>;
}

const FRDevicesConfigCard = ({
  setSelectedDeviceIPAddresses,
}: FRDevicesConfigCardProps) => {
  const { t } = useTranslation();

  const [page, setPage] = useState<number>(1);
  const [pages, setPages] = useState(1);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState<number>(PAGE_SIZE);
  const [search, setSearch] = useState("");

  const [allDevices, setAllDevices] = useState<Device[]>([]);

  const { data: devices } = useGetAllDevices({
    pageNumber: page,
    pageSize: pageSize,
    search: search,
    n_FRDeviceType: DEVICE_TYPES.FR,
  });

  useEffect(() => {
    if (devices) {
      setAllDevices(devices.data || []);
      setPages(devices.pagination?.pages || 1);
      setCount(devices.pagination?.count || 0);
    }
  }, [setPages, devices]);

  return (
    <div className="bg-white p-4 rounded-xl shadow-[0px_1px_5px_0px_rgba(113,112,163,0.3)] flex flex-col  gap-3 lg:gap-6">
      <h2 className="text-lg lg:text-xl font-medium">{t("frDevices")}</h2>

      <FRDevicesFRConfigTable
        frDevices={allDevices}
        page={page}
        pages={pages}
        setPage={setPage}
        search={search}
        setSearch={setSearch}
        count={count}
        setSelectedDeviceIPAddresses={setSelectedDeviceIPAddresses}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />
    </div>
  );
};

export default React.memo(FRDevicesConfigCard);
